import { Link } from "react-router-dom"

export default function News1() {
	return (
		<>
			<section className="news-section fix section-padding fix section-bg-2">
				<div className="shape-1 float-bob-y">
					{/* <img src="assets/img/news/shape-1.png" alt="img" /> */}
				</div>
				<div className="shape-2 float-bob-x">
					{/* <img src="assets/img/news/shape-2.png" alt="img" /> */}
				</div>
				<div className="container">
					<div className="section-title text-center">
						<h6 className="wow fadeInUp">
							<i className="fa-regular fa-arrow-left-long" />
							Blogs
							<i className="fa-regular fa-arrow-right-long" />
						</h6>
						<h2 className="wow fadeInUp" data-wow-delay=".2s">
							Latest Updates on WPC Doors & Innovations
						</h2>
					</div>
					<div className="row">
						<div className="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
							<div
								className="news-image-items bg-cover"
								style={{ backgroundImage: 'url("assets/img/news/Blog-1.png")' }}
							>
								<div className="news-content">
									<ul>
										<li>
											<i className="fa-regular fa-user" />
											By Vishal Patel
										</li>
										{/* <li>
											<i className="fa-solid fa-tag" />
											Maintenance
										</li> */}
									</ul>
									<h3>
										<Link to="/Why-WPC-Doors-Are-the-Future-of-Indian-Homes">
											Why WPC Doors Are the Future of Indian Homes ?
										</Link>
									</h3>
									{/* <p className="text-white">
										Pellentesque vitae consectetur ante Integer non eros id quam
										dapibus tincidunt non sed dolor Praesent maximus ...
									</p> */}
								</div>
							</div>
						</div>
						<div className="col-lg-6">
							<div className="news-right-items">
								<div
									className="news-card-items wow fadeInUp"
									data-wow-delay=".2s"
								>
									<div className="news-content">
										<ul>
											<li>
												<i className="fa-regular fa-user" />
												By Vishal Patel
											</li>
											{/* <li>
												<i className="fa-solid fa-tag" />
												Maintenance
											</li> */}
										</ul>
										<h4>
											<Link to="/How-To-Choose-the-Right-WPC-Door-Frame">
												WPC vs. Wooden Doors – What Should You Choose ?
											</Link>
										</h4>
										{/* <p>
											Pellentesque vitae consectetur ante <br /> Integer non
											eros...
										</p> */}
										<Link to="/How-To-Choose-the-Right-WPC-Door-Frame" className="link-btn">
											Read More <i className="fa-regular fa-arrow-right-long" />
										</Link>
									</div>
									<div className="news-image">
										<img src="assets/img/news/Blog-2.png" alt="img" style={{ width: '100%', height: '258px', objectFit: 'contain' }} />
									</div>
								</div>
								<div
									className="news-card-items wow fadeInUp"
									data-wow-delay=".4s"
								>
									<div className="news-content">
										<ul>
											<li>
												<i className="fa-regular fa-user" />
												By Vishal Patel
											</li>
											{/* <li>
												<i className="fa-solid fa-tag" />
												Maintenance
											</li> */}
										</ul>
										<h4>
											<Link to="/How-To-Choose-the-Right-WPC-Door-Frame">

												How to Choose the Right WPC Door Frame for Your Project ?
											</Link>
										</h4>
										{/* <p>
											Pellentesque vitae consectetur ante <br /> Integer non
											eros...
										</p> */}
										<Link to="/How-To-Choose-the-Right-WPC-Door-Frame" className="link-btn">
											Read More <i className="fa-regular fa-arrow-right-long" />
										</Link>
									</div>
									<div className="news-image">
										<img src="assets/img/news/Blog-3.jpg" alt="img" style={{ width: '100%', height: '258px', objectFit: 'contain' }} />
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}
